module.exports = __webpack_public_path__ + "static/herman-s-e34136316efb6b9025b8764b51d2373e.png";